import { render, staticRenderFns } from "./ProjectCategoryEdit.vue?vue&type=template&id=029c8b17"
import script from "./ProjectCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ProjectCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports